export { default } from './BoxHeader';
